import * as types from '../types'

/**
 * 发现页数据
 * recipesList: 食谱数据
 * discount:  商品优惠数据
 * presale: 预售优惠数据
 * @type {Object}
 */
const state = {
    recipesList: [],
    discount: {
        id: 1,
        title: '优惠推荐',
        thumb: 'event1.jpg',
        goodsList: []
    },
    presale: {
        id: 2,
        title: '好物预售',
        thumb: 'event2.jpg',
        goodsList: []
    }
}

const getters = {

}

const mutations = {
    [types.INIT_DISCOVER_INDEX] (state, params) {
        state.recipesList = params.recipes
        state.discount.goodsList = params.discount
        state.presale.goodsList = params.presale
    }
}

const actions = {

}

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/discover.js